import { ChevronRight as e } from "lucide-react";
import { jsx as t } from "react/jsx-runtime";
// src/design/breadcrumbs/@/components/separator/index.tsx
var n = () => /* @__PURE__ */ t("span", {
	className: "mx-1 text-muted-foreground",
	children: /* @__PURE__ */ t(e, { size: 14 })
});
n.displayName = "Separator";
export { n as Separator };

//# sourceMappingURL=index.js.map